export const CDN_BASE_URL = import.meta.env.VITE_CDN_BASE_URL;

/** Public base URL of ryc-site's own S3/R2 bucket (its `S3_PUBLIC_URL`, mirrored client-side). */
export const RYC_S3_PUBLIC_URL = import.meta.env.VITE_RESTOREYOURCORE_S3_PUBLIC_URL;
